<template>
  <div  v-if="status.length==0&&dimension.length==0&&ipo.length==0&&itOrange.length&&!highTech">
    <span>-</span>
  </div>
  <div class="Tags" style="font-size:0;" v-else>
    <!-- item!=='存续'&& item!=='迁出' -->
    <span v-for="(item,index) in status" class="comStatus" :class="{'comWarn':checkEntstatus(item)}" :key="getkeys(index,'comStatus')">{{item}}</span>
    <span v-for="(item,index) in ipo" class="comIpo" :key="getkeys(index,'comIpo')">{{item}}</span>
    <!-- 判断高新企业是否过日期，过期则不显示 -->
    <span class="comHigh" v-if='highTech'>{{highTech}}</span>
    <span v-for="(item,index) in itOrange" class="comOrange" :key="getkeys(index,'comOrange')" v-if='(dimensionShow)?(index<orangeLength-ipo.length-status.length):(index<orangeLength-ipo.length-status.length)'>{{item}}</span>
    <span v-for="( item, index ) in dimension" class="comDimension" :key="getkeys(index,'comDimension')" v-if='dimensionShow && index<orangeLength-itOrange.length-ipo.length-status.length'>{{item}}</span>
    <!-- && itOrange.length<5 -->
  </div>
</template>
<script>
import { isEmpty } from '../../common/utils';
  export default {
    props: ['row','dimensionShow'],
    data() {
      return {
        tags:[],
        status:[],
        dimension:[],
        ipo:[],
        // '官网',
        dimensionList:['实号','网络推广','商标','招聘','电子商务'],
        ipoList:['沪深主板','创业板','中小板','三板'],
        itOrangeList:['IT桔子'],
        itOrange:[],
        highTech:'',
        orangeLength:0
      };
    },
    watch:{
      row(val){
        this.getTags();
      },
    },
    methods:{
      getkeys( index, item ) {
        return index + item;
      },
      getTags(){
        let total = 0;
        this.status =[];
        this.dimension =[];
        this.ipo =[];
        this.itOrange = [];
        if(this.row && this.row.length>0){
          this.row.forEach((e,i)=>{
            if(e.category == '高新企业'){
              this.highTech = '高新企业';
              total ++;
            }
            //  && total<8  && total<limitTag
            if(e.isDisplay){
              let content;
              if(e.tagName){
                  content = e.tagName.split('-')[1]
              }
              switch(e.category){
                case "企业状态" :
                  this.status.push(content.slice(0,2));
                  total++;
                  break;
                case "维度" :
                  if(this.dimensionList.indexOf(content)!=-1){
                    this.dimension.push(content);
                    total++;
                  }
                  break;
                case "上市情况" :
                  if(this.ipoList.indexOf(content)!=-1){
                    this.ipo.push(content);//上市情况拆分
                    total++;
                  }
                  break;
                // case "高新企业" :
                //   this.highTech = '高新企业';
                //   total++;
                //   break;
                // IT桔子标签添加
                case "IT桔子" :
                  let itTagName = e.tagName || '';
                  itTagName = isEmpty( itTagName ) ? ( e.tag_name || '' ) : itTagName;
                  if( !isEmpty( itTagName ) ) {
                    this.itOrange.push(itTagName);
                    total++;
                  }
                  break;
              }
            }
          });
        }
        if(this.dimensionShow){
          this.orangeLength = (this.highTech)?(7):(8)
        }else{
           this.orangeLength = (this.highTech)?(19):(20)
        }
      }
    },
    created(){
      this.getTags();
    },
  };
</script>
<style lang="scss" scoped>
 .Tags span{
    border-radius: 2px;
    font-size: 11px;
    font-weight: normal;
    // min-width: 38px;
    height: 22px;
    line-height: 18px;
    text-align: center;
    margin:2px;
    padding:1px 6px;
    display: inline-block;
  }
 span.comStatus{
   color: #66bb6a;
   border: 1px solid #66bb6a;
 }
 span.comWarn{
   color: #ec6459;
   border: 1px solid #ec6459;
 }
 span.comDimension{
   color: #67aef5;
   border: 1px solid #67aef5;
 }
 span.comIpo{
   color: #fe9e16;
   border: 1px solid #fe9e16;
 }
 //上市
  span.comIpo{
   color: #f49025;
   border: 1px solid #f49025;
 }
 //桔子
 span.comOrange{
   color: #94a8b4;
   border: 1px solid #94a8b4;
 }
 //高新企业
 span.comHigh{
   color: #41bfbf;
   border: 1px solid #41bfbf;
 }
</style>





// WEBPACK FOOTER //
// src/components/global/tags.vue